var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateiconadd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83958 2.90006L3.36624 8.6934C3.15958 8.9134 2.95958 9.34673 2.91958 9.64673L2.67291 11.8067C2.58624 12.5867 3.14624 13.1201 3.91958 12.9867L6.06624 12.6201C6.36624 12.5667 6.78624 12.3467 6.99291 12.1201L12.4662 6.32673C13.4129 5.32673 13.8396 4.18673 12.3662 2.7934C10.8996 1.4134 9.78624 1.90006 8.83958 2.90006Z",
    stroke: "#6F00FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92773 3.8667C8.2144 5.7067 9.70773 7.11337 11.5611 7.30003",
    stroke: "#6F00FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1667H14",
    stroke: "#6F00FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateiconadd);
export default __webpack_public_path__ + "static/media/updateiconadd.ea092b4d2e57dfffffa098b7af270c51.svg";
export { ForwardRef as ReactComponent };